import React from "react";
import { HapticFeedback } from "../../utils/hapticFeedback";
import { YandexMetrika } from "../../utils/yandexMetrika";
import { useUnreadCount } from "../../hooks/useNotifications";
import { GhostModeIcon } from "../icons/GhostModeIcon";
import styles from "./ProfileFloatingButton.module.css";

interface ProfileFloatingButtonProps {
  onClick: () => void;
  theme?: "light" | "dark";
  userName?: string;
  userAvatar?: string;
  score?: number;
  isGhostMode?: boolean;
}

export const ProfileFloatingButton: React.FC<ProfileFloatingButtonProps> = ({
  onClick,
  theme = "light",
  userName = "Nickolay | Speshu",
  userAvatar = "https://placehold.co/40x40",
  isGhostMode = false,
}) => {
  const { unreadCount } = useUnreadCount(true);

  const handleClick = () => {
    HapticFeedback.medium();
    YandexMetrika.goToProfile();
    onClick();
  };

  return (
    <button
      className={`${styles.profileFloatingButton} ${
        theme === "dark" ? styles.dark : ""
      }`}
      onClick={handleClick}
    >
      <div className={styles.profileAvatarWrapper}>
        <img className={styles.profileAvatar} src={userAvatar} alt="Профиль" />
        {unreadCount > 0 && <div className={styles.notificationBadge} />}
      </div>
      <div className={styles.profileInfo}>
        <div className={styles.profileName}>
          {userName}
          {isGhostMode && (
            <span className={styles.ghostIcon}>
              <GhostModeIcon width={16} height={16} color="currentColor" />
            </span>
          )}
        </div>
        <div className={styles.profileStats}>
          {/* <div className={styles.profileBattery}>
            <div className={styles.profileBatteryIcon}>
              <div className={styles.profileBatteryFill} />
            </div>
            <div className={styles.profileBatteryBar} />
          </div> */}
          {/* <div className={styles.profileScore}>{score}</div> */}
        </div>
      </div>
    </button>
  );
};
